import { render, staticRenderFns } from "./OkDialog.vue?vue&type=template&id=e0c3cc8c&"
import script from "./OkDialog.vue?vue&type=script&lang=ts&"
export * from "./OkDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports